import Vue from 'vue'
import Vuex from 'vuex'

import { sessionStore } from './modules/session-store'
import { serviceHierarchyStore } from './modules/service-hierarchy-store'
import { serviceOverviewStore } from './modules/service-overview-store'
import { marketPlaceHierarchyStore } from './modules/marketplace-hierarchy-store'
import { marketplaceOverviewStore } from './modules/marketplace-overview-store'
import { customerStoryStore } from './modules/customer-story-store'
import { commonStore } from './modules/common-store'
import { billingStore } from './modules/billing-store'
import { calculationStore } from './modules/calculation-store'
import { gnbStore } from './modules/gnb-store'
import { pricingStore } from './modules/pricing-store'
import { cmsStore } from './modules/cms-store'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    [commonStore.namespace]: {
      ...commonStore,
      namespaced: true
    },
    [gnbStore.namespace]: {
      ...gnbStore,
      namespaced: true
    },
    [sessionStore.namespace]: {
      ...sessionStore,
      namespaced: true
    },
    [serviceHierarchyStore.namespace]: {
      ...serviceHierarchyStore,
      namespaced: true
    },
    [serviceOverviewStore.namespace]: {
      ...serviceOverviewStore,
      namespaced: true
    },
    [marketPlaceHierarchyStore.namespace]: {
      ...marketPlaceHierarchyStore,
      namespaced: true
    },
    [marketplaceOverviewStore.namespace]: {
      ...marketplaceOverviewStore,
      namespaced: true
    },
    [customerStoryStore.namespace]: {
      ...customerStoryStore,
      namespaced: true
    },
    [billingStore.namespace]: {
      ...billingStore,
      namespaced: true
    },
    [calculationStore.namespace]: {
      ...calculationStore,
      namespaced: true
    },
    [pricingStore.namespace]: {
      ...pricingStore,
      namespaced: true
    },
    [cmsStore.namespace]: {
      ...cmsStore,
      namespaced: true
    }
  }
})

export default store
